import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'

const DEFAULT_TEXT = 'Credible Operations, Inc. NMLS # 1681276'
export const PAID_AD_TEXT = 'Paid Advertisement. Credible Operations, Inc. NMLS # 1681276'

const Nmls = ({ show = false, text = DEFAULT_TEXT }) =>
  show && <p className={styles.nmls}>{text}</p>

Nmls.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.string,
}

export default Nmls
